import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Order } from '../types/types';
import dataService from '../data/dataService';
import '../styles/OrderDetail.css';

const OrderDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [order, setOrder] = useState<Order | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (id) {
      dataService.getOrder(parseInt(id)).then(setOrder).catch(() => {}).finally(() => setLoading(false));
    }
  }, [id]);

  if (loading) return <div className="order-detail-page"><p>Loading...</p></div>;
  if (!order) return <div className="order-detail-page"><p>Order not found.</p></div>;

  return (
    <div className="order-detail-page">
      <Link to="/orders" className="back-link">&larr; Back to Orders</Link>
      <h1>Order #{order.id}</h1>
      <div className="order-detail-meta">
        <span className={`order-status status-${order.status.toLowerCase()}`}>{order.status}</span>
        <span>Placed: {new Date(order.createdAt).toLocaleString()}</span>
        {order.updatedAt && <span>Updated: {new Date(order.updatedAt).toLocaleString()}</span>}
      </div>

      <table className="order-detail-table">
        <thead>
          <tr><th>Product</th><th>Qty</th><th>Price</th><th>Subtotal</th></tr>
        </thead>
        <tbody>
          {order.items?.map((item, idx) => (
            <tr key={idx}>
              <td><Link to={`/product/${item.productId}`}>{item.productName}</Link></td>
              <td>{item.quantity}</td>
              <td>${item.unitPrice.toFixed(2)}</td>
              <td>${item.subtotal.toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="order-detail-total">
        <strong>Total: ${order.total.toFixed(2)}</strong>
      </div>
    </div>
  );
};

export default OrderDetail;
